// Separate from eventable so tests that replace that barrel do not have to stub this helper.
export const syncSnowplowUserId = (userId?: number | null) => {
  void import(/* webpackChunkName: "eventable" */ './eventableCallbacks').then(({ syncSnowplowUserId: sync }) => {
    sync(userId);
  });
};
